import { ActionDescriptor } from '../common/commonTypes';
import LoadAttributeForm from './loadAttributeForm';

const loadAttribute: ActionDescriptor = {
	FormComponent: LoadAttributeForm,
	actionTitle: 'Load',
};

export default loadAttribute;
